import { createContext } from "react";
import { AmplitudeClient } from "./clients/amplitude";
import { MoengageClient } from "./clients/moengage.client";

export const LogEvents = {
  PageView: "PageView",
  NewBid: "NewBid",
  sessionStart: "sessionStart",
  getOtp: "getOtp",
  verifyOTP: "verifyOTP",
  allProject: "allProject",
  vendors: "vendors",
  approvals: "approvals",
  explore: "explore",
  logOut: "logOut",
  myProfile: "myProfile",
  organizationSettings: "organizationSettings",
  selectBranch: "selectBranch",
  createProjectInitiate: "createProjectInitiate",
  selectProject: "selectProject",
  createProjectSuccess: "createProjectSuccess",
  addVendor: "addVendor",
  searchVendor: "searchVendor",
  selectVendor: "selectVendor",
  customizeVendorMenu: "customizeVendorMenu",
  empaneledVendors: "empaneledVendors",
  searchByKeyword: "searchByKeyword",
  filterByDistance: "filterByDistance",
  editVendorDetails: "editVendorDetails",
  getNumber: "getNumber",
  searchEmpaneledVendor: "searchEmpaneledVendor",
  bulkUploadVendor: "bulkUploadVendor",
  downloadVendorExample: "downloadVendorExample",
  addFinancialDetails: "addFinancialDetails",
  vendorSubmit: "vendorSubmit",
  editFinancialDetails: "editFinancialDetails",
  submitVendorEditDetail: "submitVendorEditDetail",
  approvalForMe: "approvalForMe",
  poWoByMe: "poWoByMe",
  seePoApprovalDetails: "seePoApprovalDetails",
  customizePoMenu: "customizePoMenu",
  approvePo: "approvePo",
  rejectPo: "rejectPo",
  addProjectMembers: "addProjectMembers",
  withTax: "withTax",
  projectDashboard: "projectDashboard",
  projectBudget: "projectBudget",
  projectPoWo: "projectPoWo",
  projectSettings: "projectSettings",
  projectBiddings: "projectBiddings",
  projectFiles: "projectFiles",
  projectExplore: "projectExplore",
  dashboardDownload: "dashboardDownload",
  customizeGraphs: "customizeGraphs",
  budgetAndActualGraphWithTax: "budgetAndActualGraphWithTax",
  addBoqItem: "addBoqItem",
  editDetailsBudget: "editDetailsBudget",
  downloadBudget: "downloadBudget",
  addSubItem: "addSubItem",
  seeItemPoDetails: "seeItemPoDetails",
  bulkUploadSubItem: "bulkUploadSubItem",
  customizeBudgetMenu: "customizeBudgetMenu",
  searchBudgetItem: "searchBudgetItem",
  submitBoqItem: "submitBoqItem",
  bulkUploadItem: "bulkUploadItem",
  bulkUploadRateContract: "bulkUploadRateContract",
  selectBoqCategory: "selectBoqCategory",
  selectBoqTaxValue: "selectBoqTaxValue",
  selectBoqTaxType: "selectBoqTaxType",
  downloadBoqExample: "downloadBoqExample",
  uploadBoqList: "uploadBoqList",
  createPoWo: "createPoWo",
  createRateContract: "createRateContract",
  customizePoWoMenu: "customizePoWoMenu",
  customizeRateContractTable: "customizeRateContractTable",
  seeDetailsPoWo: "seeDetailsPoWo",
  createPoWoFromBudgetTable: "createPoWoFromBudgetTable",
  searchByStatus: "searchByStatus",
  poActions: "poActions",
  typeOfOrder: "typeOfOrder",
  deliveryDate: "deliveryDate",
  selectGstRate: "selectGstRate",
  addShipingAddress: "addShipingAddress",
  addAndRemoveBoqItem: "addAndRemoveBoqItem",
  addTermClick: "addTermClick",
  dateOfPayment: "dateOfPayment",
  addCondition: "addCondition",
  termsAndConditions: "termsAndConditions",
  addAdditionalCharges: "addAdditionalCharges",
  uploadPoDocument: "uploadPoDocument",
  sendPO: "sendPO",
  additionalCharges: "additionalCharges",
  additionalChargesGstType: "additionalChargesGstType",
  additionalChargesGstPercent: "additionalChargesGstPercent",
  submitShipingAddress: "submitShipingAddress",
  selectBoqItem: "selectBoqItem",
  submitaddItem: "submitaddItem",
  bidInitiate: "bidInitiate",
  customizeBidMenu: "customizeBidMenu",
  seeBidDetails: "seeBidDetails",
  vendorDetail: "vendorDetail",
  addRemoveBidItem: "addRemoveBidItem",
  bidSubmit: "bidSubmit",
  organizationProfile: "organizationProfile",
  organizationBranches: "organizationBranches",
  organizationCategories: "organizationCategories",
  organizationTermsAndConditions: "organizationTermsAndConditions",
  organizationGstDetails: "organizationGstDetails",
  organizationMembers: "organizationMembers",
  organizationApprovalFlow: "organizationApprovalFlow",
  downloadAllPoWoData: "downloadAllPoWoData",
  saveOrganizationChanges: "saveOrganizationChanges",
  addOrganizationBranch: "addOrganizationBranch",
  editOrganizationDetail: "editOrganizationDetail",
  submitOrganizationBranch: "submitOrganizationBranch",
  addApprovalFlowStep: "addApprovalFlowStep",
  submitApprovalFlow: "submitApprovalFlow",
  categoryStatus: "categoryStatus",
  editcategoryDetails: "editcategoryDetails",
  addOrganizationCategory: "addOrganizationCategory",
  addnewTermsandConditions: "addnewTermsandConditions",
  addOrganizationGstDetail: "addOrganizationGstDetail",
  addOrganizationApprovalFlowStep: "addOrganizationApprovalFlowStep",
  submitOrganizationApprovalFlowStep: "submitOrganizationApprovalFlowStep",
  addSignature: "addSignature",
  addAvatar: "addAvatar",
  viewWishlist: "viewWishlist",
  addProduct: "addProduct",
  viewOrganisationProducts: "viewOrganisationProducts",
  searchProduct: "searchProduct",
  addProductSuccess: "addProductSuccess",
  addProductImages: "addProductImages",
};

export class Logger {
  _clients = [];

  addClient(apiKey, client = "amplitude") {
    switch (client) {
      case "amplitude":
        this._clients.push(new AmplitudeClient(apiKey));
        break;
      case "moengage":
        this._clients.push(new MoengageClient(apiKey));
        break;
      default:
        break;
    }
  }

  log(event, data = {}) {
    this._clients.forEach((client) => {
      client?.log(event, data);
    });
  }

  identify(data) {
    this._clients.forEach((client) => {
      if (!client.identify) return;
      client.identify(data);
    });
  }
}

export const LoggerContext = createContext(new Logger());
